import ClubItemBase from "./club_item_base";
import ClubMemberBase from "./club_member_base";
import ClubMemberPop from "../member_manger/club_member_pop_module";
import ModuleManager from "../../../framework/core/module_manager";
import { club_utils } from "../club_utils";



const {ccclass, property} = cc._decorator;

@ccclass
export default class ClubMemberItem extends ClubMemberBase {
        

    @property(cc.Node)
    setCurrency : cc.Node = null;

    @property(cc.Node)
    rank : cc.Node = null;

    @property(cc.Node)
    remove : cc.Node = null;

    @property(cc.Node)
    addfriend : cc.Node = null;

    updateInfo(data:any){
        super.updateInfo(data);
        this.dispatchEvent("club_member_update_rank",data);
        this.updateButtons()
    }

    private updateButtons(){
 
        //item是否为自己
        if(this.isSelf){

            this.addfriend.active = false;
            this.remove.active = false;
            this.rank.active = false;
            this.setCurrency.active = this.isAdmin;

        }else if(club_utils.isAdmin && !this.isOwner){

            //自己是管理员 且 改成员不能是创建者
            this.addfriend.active = true;
            this.remove.active = true;
            this.rank.active = true;
            this.setCurrency.active = true;

        }else{

            //自己是普通成员
            this.setCurrency.active = false;
            this.remove.active = false;
            this.rank.active = false;
            this.addfriend.active = true;

        }
    }
    

    onClickMemeber(){

        this.dispatchEvent("club_click_member_item")
    }

    /**
     * 设置筹码
     */
    onSetCurrency(){

        ModuleManager.instance.showModule(ClubMemberPop,{index : this.itemIndex , data : this.data });
    }

    /**
     * 官阶升降
     */
    onRankMgr(){


        if (this.isAdmin) {
            //降职
            club_utils.reqDownMember(this.itemIndex,this.mvvmBase,(result)=>{
                if (result) {
                    this.data.clubUserType = "player";
                    this.updateInfo(this.data);
                    
                    this.dispatchEvent("club_member_update_rank",this.data);

                }else{

                }
            });
        }else{

            //升职
            club_utils.reqUpgradeMember(this.itemIndex,this.mvvmBase,(result)=>{
                if (result) {
                    //更新官阶
                    this.data.clubUserType = "admin";
                    this.updateInfo(this.data);

                    this.dispatchEvent("club_member_update_rank",this.data);
                }
            });
        }
        
    }

    /**
     * 移除俱乐部
     */
    onRemoveMember(){

        this.dispatchEvent("club_request_remove_club");

    }

    /**
     * 加/删 好友 
     */
    onAddFriend(){

        //判断好友关系
        this.dispatchEvent("club_request_add_friend");
    }

    /**
     * 邀请加入
     */
    onInviteJoin(){
        this.dispatchEvent("club_request_invite_join");
    }
  
}
